'use strict';
var twentyninetimes = twentyninetimes || {};

twentyninetimes.accordion = twentyninetimes.accordion || function () {

	function init() {
		const hasAccordions = document.querySelector('.js-accordion');

		if ( hasAccordions ) {
			accordionToggle();
		}
	}

	function accordionToggle() {
    window.addEventListener('click', function(e) {
      var accordionToggle = e.target.closest('.js-accordion-toggle');

      if (!accordionToggle) return;

			e.stopPropagation();

      var accordion = accordionToggle.closest('.js-accordion'),
          accordionContent = accordion.querySelector('.js-accordion-content');

      // If accordion has attribute accordion-focus, close any other open accordion
      if ( accordion.hasAttribute('accordion-focus') ) {
        var currentProduct = accordion.parentNode.querySelector('.js-accordion.active');
  
        if ( currentProduct ) {
          var currentToggle = currentProduct.querySelector('.js-accordion-toggle'),
              currentContent = currentProduct.querySelector('.js-accordion-content');
  
          closeAccordion(currentProduct, currentToggle, currentContent);
        }
      }

      // Toggle accordion
      ( !accordion.classList.contains('active') )
        ? openAccordion(accordion, accordionToggle, accordionContent)
        : closeAccordion(accordion, accordionToggle, accordionContent);
		});
	}

	function openAccordion(accordion, toggle, content) {
		toggle.setAttribute('aria-expanded', true);
		accordion.classList.add('active');

    // Get accordion content height, save it to a variable and set height to 0 again
		content.style.height = 'auto';
		var accordionHeight = content.clientHeight;
		content.style.height = '0px';

    // Load any images inside accordion with the data-src attribute
    var image_src = content.querySelectorAll('img[data-src]');
    if ( image_src ) {
      image_src.forEach(image => {
        var src = image.getAttribute('data-src');
        image.setAttribute('src', src);
        image.removeAttribute('data-src');
      });
    }

		setTimeout(function () {
			content.style.height = accordionHeight + 'px';

			setTimeout(function () {
        // Make accordion height dynamic when transition is done
				if ( accordion.classList.contains('active') ) {
					content.style.height = 'auto';
				}
			}, 500);
		}, 10);
	}

	function closeAccordion(accordion, toggle, content) {
		var accordionHeight = content.clientHeight;
		content.style.height = accordionHeight + 'px';

		setTimeout(function () {
			content.style.height = '0px';
			accordion.classList.remove('active');
		}, 10);

		toggle.setAttribute('aria-expanded', false);
	}

	return {
		init : init
	};

}();